import script from "./formoverduetj.vue?vue&type=script&lang=ts&setup=true"
export * from "./formoverduetj.vue?vue&type=script&lang=ts&setup=true"

import "./formoverduetj.vue?vue&type=style&index=0&id=0533e6cd&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0533e6cd"]])

export default __exports__